import { render } from "./PageTitle.vue?vue&type=template&id=76f4998c&scoped=true"
import script from "./PageTitle.vue?vue&type=script&lang=js"
export * from "./PageTitle.vue?vue&type=script&lang=js"

import "./PageTitle.vue?vue&type=style&index=0&id=76f4998c&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-76f4998c"

export default script